export const ABOUT_CONSTS = {
    UPDATE_ABOUT_SLIDER_BY_ID: "UPDATE_ABOUT_SLIDER_BY_ID",
    SET_ABOUT_DATA:"SET_ABOUT_DATA",
};
